import { render, staticRenderFns } from "./QuitaCrudPage.vue?vue&type=template&id=1452aa36"
import script from "./QuitaCrudPage.vue?vue&type=script&lang=js"
export * from "./QuitaCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports